"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotaoGrupo = void 0;
var estiloBotaoGrupo = require('./BotaoGrupo.module.scss');
var react_1 = __importDefault(require("react"));
var Botao_1 = require("../Botao/Botao");
var Icone_1 = require("../Icone/Icone");
var Cores_1 = require("../Cores/Cores");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var BotaoGrupo = function (_a) {
    var id = _a.id, _b = _a.opcoes, opcoes = _b === void 0 ? [] : _b;
    var _c = react_1.default.useState(opcoes[0].valorSelecionado), selecionado = _c[0], setSelecionado = _c[1];
    var handleClick = function (botao) {
        setSelecionado(botao.valorSelecionado);
        botao.onClick && botao.onClick(botao.valorSelecionado);
    };
    var criarBotao = function (botao) {
        var indexStyle = '';
        if (botao.valorSelecionado === opcoes[0].valorSelecionado)
            indexStyle = estiloBotaoGrupo.inicio;
        else if (botao.valorSelecionado === opcoes[opcoes.length - 1].valorSelecionado)
            indexStyle = estiloBotaoGrupo.fim;
        else
            indexStyle = '';
        return (react_1.default.createElement("div", { className: "\n                ".concat(estiloBotaoGrupo.botao, " \n                ").concat(indexStyle, " \n                ").concat(selecionado === botao.valorSelecionado ? estiloBotaoGrupo.selecionado : '', "\n            ") },
            react_1.default.createElement(Botao_1.Botao, { id: botao.valorSelecionado, tipoComportamento: "button", onClick: function () { return handleClick(botao); }, estilo: "ghost", tamanho: "medium" },
                botao.icone && react_1.default.createElement(Icone_1.Icone, { nome: botao.icone, cor: selecionado === botao.valorSelecionado ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU100 : Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600 }),
                react_1.default.createElement(Corpo_1.Corpo, { tipo: "button1", negrito: 700, cor: selecionado === botao.valorSelecionado ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU100 : Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600 }, botao.texto))));
    };
    return (react_1.default.createElement("div", { id: id, className: estiloBotaoGrupo.container }, opcoes.map(function (opcao) { return criarBotao(opcao); })));
};
exports.BotaoGrupo = BotaoGrupo;
